import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useTranslation } from "../../../locale/useTranslation";
import BossDialog from "../../../components/BossDialog";
import { utility } from "../../../framework/utility/utilityProvider";

export const ResponseTable = (props) => {

    let popup = props.popup ?? true;

    const [finalDisplayValue, setFinalDisplayValue] = useState([]);
    const [showObjectDetails, setShowObjectDetails] = useState(false);
    const [selectedObjectData, setSelectedObjectData] = useState({});

    const lang = useTranslation();
    const filterSearchRef = useRef();
    const title = lang.details_label + (props.details ? " - " + props.details?.Event + " (" + props.details?.User + " - " + props.details?.EntryDateTime + ")" : "");

    useEffect(() => {
        getDipslayValue();
    }, []);

    const getValueFromObject = (value, key,) => {

        switch (key.toLowerCase()) {
            case 'channel':
            case 'channels':
                return value?.FullChannelName;
            case 'addby':
            case 'modby':
            case 'reportingto':
                return value?.name;
            case 'mediadealrights':
            case 'publishings':
                return value?.Channel?.map(x => x?.FullChannelName).join(",") + value?.Platform?.map(x => x?.Description).join(",") + " - " + value?.PlatformType?.Description + " ( " + moment(new Date(value?.PublishStartDate)).format("YYYY-MM-DD") + " - " + moment(new Date(value?.PublishEndDate)).format("YYYY-MM-DD") + " )";
            case 'synopsis':
                return value?.Synopsis
            case 'audiotrack':
            case 'localization':
                return value?.Language?.Description;
            case 'segmentdetails':
                return value?.MediaId
            case 'formatdetail':
                return value?._id
            case 'style':
                return value?.color
            case 'roletype':
                return value?.NAME
            case 'segments':
            case 'segment':
                return value?.SegmentType?.Description
        }
        return value?.Description ? value?.Description : value?.Title ? value?.Title : value?.Name ? value?.Name : value?.SegmentType?.Title ? value?.SegmentType?.Title : Object.keys(value).length > 0 ? JSON.stringify(value) : "";
    }
    const getValueFromArray = (value, key) => {
        let tempData = [];

        switch (key?.toLowerCase()) {

            default:
                value?.forEach((item) => {
                    let temp = getValueFromObject(item, key);
                    tempData.push(temp);
                });
                return tempData?.join(", ") || "";
        }
    };

    const getValue = (value, key) => {

        if (value == undefined || value == null) {
            return "";
        }
        let type = typeof value;
        switch (type) {
            case "object":
                if (Array.isArray(value)) {
                    return getValueFromArray(value, key);
                } else {
                    return getValueFromObject(value, key);
                }
            case "string":
                return value;
            case "number":
                if (key.toLowerCase().includes("scheduledate") || key.toLowerCase().includes("slotdatetime")) {
                    return utility.convertMilisecondsToDateTimeString(value);
                } else if (key.toLowerCase().includes("periodfrom") || key.toLowerCase().includes("periodto") || key.toLowerCase().includes("date") || key.toLowerCase().includes("modon") || key.toLowerCase().includes("addon") || key.toLowerCase().includes("orderdate") || key.toLowerCase().includes("nominalonair") || key.toLowerCase().includes("exclusivestartdate") || key.toLowerCase().includes("exclusiveenddate") || key.toLowerCase().includes("publishstartdate") || key.toLowerCase().includes("publishenddate")) {
                    return moment(value).format("DD-MM-YYYY HH:mm:ss");
                } else if (key.toLowerCase().includes("time") || key.toLowerCase().includes("duration") || key.toLowerCase().includes("tcin") || key.toLowerCase().includes("tcout")) {
                    return moment.utc(value).format("HH:mm:ss");
                } else {
                    return value;
                }
            case "boolean":
                return value ? "Yes" : "No";
            default:
                return value;
        }
    }

    const getDipslayValue = () => {
        let finalPreareData = [];
        Object.keys(props?.value)?.map(key => {
            if (key == "_id" || key == "SID" || key == "modOn" || key == "modBy") {
                return;
            }
            let value = props.value ? props.value[key] : "";

            let tempData = {};
            tempData.Properties = key;
            tempData.Value = value;

            finalPreareData.push(tempData);
        })

        console.log(finalPreareData);

        setFinalDisplayValue(finalPreareData);
        filterSearchRef.current = finalPreareData;


    }

    const ResponseUI = () => (
        <div className="row" style={{ margin : '0px'}}>
            {finalDisplayValue?.length > 0 ? (
                <div className="col-12" style={{ padding : '0px 15px' , width: "100%" }}>
                    <table className="table table-bordered table-hover border" style={{ width: "100%" }}>
                        <thead style={{ position: 'sticky', top: '0', background: "#ffffff", zIndex: '1' }}>
                            <tr className="border">
                                {Object.keys(finalDisplayValue[0])?.map((item, index) => {
                                    return (
                                        <th key={index} className="border" >{item}</th>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {finalDisplayValue?.map((rowItem, index) => (
                                <tr key={index} style={{
                                    background: "none"
                                }}>
                                    {Object.keys(rowItem).map((key, index) => {

                                        return (
                                            <td key={index} className="border" >
                                                <div>
                                                    {rowItem && getValue(rowItem[key], rowItem?.Properties)}
                                                    {typeof rowItem[key] === "object" &&
                                                        (rowItem && rowItem[key] && Object.keys(rowItem[key])?.length > 0)
                                                        && <div className="fa fa-info-circle ml-1 cursor-pointer" onClick={() => { setShowObjectDetails(true); setSelectedObjectData(rowItem && rowItem[key]) }}></div>}
                                                </div>
                                            </td>
                                        )
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="text-center mt-2">{lang.no_record_found_error_message}</div>
            )}

            {showObjectDetails && <ResponseTable onClose={() => setShowObjectDetails(false)} value={selectedObjectData} width="750px" height="420px" />}
        </div>
    )

    if (popup) {
        return (
            <>
                <BossDialog
                    title={title}
                    onClose={props.onClose}
                    width={props.width ?? "870px"}
                    height={props.height ?? "480px"}
                >
                    <ResponseUI />
                </BossDialog>
            </>
        )
    } else {

        return (
            <div style={{ width: "100%" }}>
            <ResponseUI />
            </div>
        )
    }

}